import { ModelRow } from "@mcleod/core";
import { AutogenLayoutExtraPayChangeCompareItem as AutogenLayoutExtraPayChangeCompareItem } from "./autogen/AutogenLayoutExtraPayChangeCompareItem";
import { DataSourceMode, TableRowDisplayEvent } from "@mcleod/components";
import { BaseCompare } from "./BaseCompare";

export class ExtraPayChangeCompareItem extends AutogenLayoutExtraPayChangeCompareItem {
    private _compareItems: ModelRow[];
    private _isCompareHistory: boolean = false;
    private _isOrderUpdateAllowed: boolean = true;
    private baseCompare = new BaseCompare();


    public get isOrderUpdateAllowed(): boolean {
        return this._isOrderUpdateAllowed;
    }

    public set isOrderUpdateAllowed(value: boolean) {
        this._isOrderUpdateAllowed = value;
    }

    override onLoad(): void | Promise<void> {
        this.tableChangeCompareItems.dataSource;
        this.tableChangeCompareItems.dataSource = this.sourceEdiCompareItem;
        this.tableChangeCompareItems.dataSource.data = [];
        const newTable = this.filterTable();
        if (newTable != null) {
            if (newTable.length === 0) {
                this.tableChangeCompareItems.visible = false;
            } else {
                this.tableChangeCompareItems.dataSource.setRowsAndMode(DataSourceMode.NONE, newTable);
            }
        }

    }

    public async setupTableData(data: ModelRow[]) {
        this._compareItems = data;
        this.tableChangeCompareItems.dataSource;
        this.tableChangeCompareItems.dataSource = this.sourceEdiCompareItem;
        this.tableChangeCompareItems.dataSource.data = [];
        if (this._compareItems != null)
            this.tableChangeCompareItems.dataSource.setRowsAndMode(DataSourceMode.NONE, this._compareItems);

        if (this._compareItems != null && this._compareItems.length == 0) {
            this.tableChangeCompareItems.visible = false;
        }
    }

    onItemRowDisplay(event: TableRowDisplayEvent) {
        this.baseCompare.isOrderUpdateAllowed = this.isOrderUpdateAllowed;
        this.baseCompare.isCompareHistory = this.isCompareHistory;
        this.baseCompare.setupCheckboxBehavior(event.getTableRow(), this.isOrderUpdateAllowed, false);
    }


    private filterTable(): ModelRow[] {
        let newTable = [];
        if (this._compareItems?.length > 0) {
            const changeType = this._compareItems[0].get("change_type");
            if (changeType == "NE") {
                newTable = this._compareItems.filter(value => {
                    const sourceValue = value.get("source_value");
                    if (sourceValue !== null && sourceValue !== "" && sourceValue !== undefined) {
                        return value;
                    }
                });
            } else if (changeType == "ER") {
                newTable = this._compareItems.filter(value => {
                    const sourceValue = value.get("target_value");
                    if (sourceValue !== null && sourceValue !== "" && sourceValue !== undefined) {
                        return value;
                    }
                });
            }
            else {
                newTable = this._compareItems;
            }
        } else {
            newTable = this._compareItems;
        }
        return newTable;
    }

    public get isCompareHistory(): boolean {
        return this._isCompareHistory;
    }

    public set isCompareHistory(isCompareHistory: boolean) {
        this._isCompareHistory = isCompareHistory;
    }

}
